export const addUser = user => ({
  type: "ADD_USER",
  user
});

export const updateUser = user => ({
  type: "UPDATE_USER",
  user
});

export const switchUser = user => ({
  type: "SWITCH_USER",
  user
});

export const logout = user => ({
  type: "LOGOUT",
  user
});
